import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const notifications = [{
  name: 'Matías G.',
  location: 'Buenos Aires',
  time: 'hace 2 min'
}, {
  name: 'Valentina R.',
  location: 'Córdoba',
  time: 'hace 5 min'
}, {
  name: 'Franco L.',
  location: 'Rosario',
  time: 'hace 8 min'
}, {
  name: 'Camila T.',
  location: 'Mendoza',
  time: 'hace 12 min'
}, {
  name: 'Nicolás P.',
  location: 'Buenos Aires',
  time: 'hace 15 min'
}, {
  name: 'Lucía M.',
  location: 'La Plata',
  time: 'hace 19 min'
}, {
  name: 'Sebastián V.',
  location: 'Tucumán',
  time: 'hace 23 min'
}, {
  name: 'Agustina F.',
  location: 'Mar del Plata',
  time: 'hace 27 min'
}, {
  name: 'Tomás B.',
  location: 'Santa Fe',
  time: 'hace 31 min'
}, {
  name: 'Julieta C.',
  location: 'Salta',
  time: 'hace 35 min'
}, {
  name: 'Ezequiel M.',
  location: 'Buenos Aires',
  time: 'hace 38 min'
}, {
  name: 'Florencia D.',
  location: 'Neuquén',
  time: 'hace 42 min'
}, {
  name: 'Rodrigo S.',
  location: 'Córdoba',
  time: 'hace 46 min'
}, {
  name: 'Micaela H.',
  location: 'Rosario',
  time: 'hace 50 min'
}, {
  name: 'Ignacio W.',
  location: 'Bahía Blanca',
  time: 'hace 54 min'
}, {
  name: 'Sofía A.',
  location: 'Mendoza',
  time: 'hace 58 min'
}, {
  name: 'Leandro Q.',
  location: 'San Juan',
  time: 'hace 1 h'
}, {
  name: 'Natalia E.',
  location: 'Buenos Aires',
  time: 'hace 1 h'
}];
export function SocialProofToast() {
  const [current, setCurrent] = useState<number | null>(null);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    // First toast after 4s
    const initial = setTimeout(() => {
      setCurrent(0);
      setIndex(0);
    }, 4000);
    return () => clearTimeout(initial);
  }, []);
  useEffect(() => {
    if (current === null) return;
    // Hide after 4s, then show next after 2s pause
    const hideTimer = setTimeout(() => {
      setCurrent(null);
    }, 4000);
    const nextTimer = setTimeout(() => {
      const next = (index + 1) % notifications.length;
      setIndex(next);
      setCurrent(next);
    }, 7000); // 4s visible + 3s pause
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [current, index]);
  const notif = current !== null ? notifications[current] : null;
  return <div className="fixed bottom-24 left-4 z-40 md:bottom-8 pointer-events-none" data-id="element-367">
      <AnimatePresence mode="wait" data-id="element-368">
        {notif && <motion.div key={current} initial={{
        opacity: 0,
        x: -60,
        scale: 0.95
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -40,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="flex items-center gap-3 bg-[#111] border border-white/10 rounded-xl px-4 py-3 shadow-2xl max-w-[260px]" data-id="element-369">
            {/* Avatar */}
            <div className="w-9 h-9 rounded-full bg-[#C9A84C]/20 border border-[#C9A84C]/40 flex items-center justify-center shrink-0" data-id="element-370">
              <span className="text-[#C9A84C] text-sm font-bold" data-id="element-371">
                {notif.name[0]}
              </span>
            </div>

            {/* Text */}
            <div className="min-w-0" data-id="element-372">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-373">
                {/* Green dot */}
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0" data-id="element-374" />
                <p className="text-white text-[12px] font-semibold truncate" data-id="element-375">
                  {notif.name}
                </p>
              </div>
              <p className="text-gray-400 text-[11px] leading-tight" data-id="element-376">
                acaba de reservar su lugar
              </p>
              <p className="text-gray-600 text-[10px] mt-0.5" data-id="element-377">
                {notif.location} · {notif.time}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}